import { useState, useEffect } from 'react';
import { getConsent, setConsent } from '@/lib/consent';
import { initAnalytics } from '@/lib/analytics';
import { routes } from '@/lib/routes';

export function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = getConsent();
    // Show banner if no decision has been made (analytics === null)
    setShow(consent.analytics === null);
  }, []);

  const handleReject = () => {
    setConsent(false);
    setShow(false);
  };

  const handleAccept = () => {
    setConsent(true);
    setShow(false);
    // Initialize analytics after consent is given
    try {
      initAnalytics();
    } catch {
      // Silently fail if initialization fails
    }
  };

  if (!show) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t border-neutral-200 shadow-lg">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1 text-sm text-neutral-700">
          By using this website, you agree to our{' '}
          <a href={routes.legal.terms()} className="text-neutral-900 underline hover:text-neutral-700 transition-colors">
            Terms of Use
          </a>
          {' '}and{' '}
          <a href={routes.legal.privacy()} className="text-neutral-900 underline hover:text-neutral-700 transition-colors">
            Privacy Policy
          </a>
          . We use essential cookies to run Lumiplot and optional analytics cookies to understand usage and improve the product.
        </div>
        <div className="flex gap-2 flex-shrink-0">
          <button
            onClick={handleReject}
            className="px-4 py-2 text-sm font-medium text-neutral-700 bg-neutral-100 border border-neutral-300 rounded hover:bg-neutral-200 transition-colors"
          >
            Reject analytics
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 text-sm font-medium text-white bg-neutral-900 border border-neutral-900 rounded hover:bg-neutral-800 transition-colors"
          >
            Accept analytics
          </button>
        </div>
      </div>
    </div>
  );
}

